class MainProduct extends HTMLElement {
  constructor() {
    super();

    this.variantTitle = this.querySelector(".product__variant-title");
    this.productStockBlock = this.querySelector(".product__stock");

    this.variantInputs = this.querySelectorAll(
      'input[type="radio"][name="id"]'
    );
    this.quantityInput = this.querySelector(
      'input[type="number"][name="quantity"]'
    );
    this.quantityOptions = this.querySelectorAll(
      'input[type="radio"][name="quantity-range"]'
    );


    this.stock = Number(document.querySelector('#variant-stock').dataset.stock);
    this.policy = document.querySelector('#variant-stock').dataset.policy;
    this.available = document.querySelector('#variant-stock').hasAttribute("data-available");    
    this.oos_text = document.querySelector('#variant-stock').dataset.oos;
    this.atc_text = document.querySelector('#variant-stock').dataset.atc;

    this.atcBtn = this.querySelector('button[type="submit"]');

    this.btnPlus = this.querySelector('[data-qty-plus]');
    this.btnMinus = this.querySelector('[data-qty-minus]');


    this.min = Number(this.quantityInput.min) || 1;
    this.max = Number(this.quantityInput.max) || Infinity;
  }

  connectedCallback() {
    this.updateButton();

    this.variantInputs.forEach((input) =>
      input.addEventListener("change", this.handleVariantChange.bind(this))
    );
    this.handleStickyAddToCard();
    
    if(this.quantityInput) {
      this.handleQuantityInput();
    }
    if(this.quantityOptions) {      
      this.handleQuantityOptions();
    }
    this.btnPlus.addEventListener('click', () => this.change(1));
    this.btnMinus.addEventListener('click', () => this.change(-1));

    this.quantityInput.addEventListener('change', () => {
      this.quantityInput.value = this.normalize(this.quantityInput.value);
    });
  }


   updateButton() {    
    // console.log('this', this.available)
    // if(this.available == true) {
    //   this.enableATC();
    // } else {
    //   this.disableATC();
    // }    
  }

  disableATC() {
    this.atcBtn.setAttribute('disabled', true);
    this.atcBtn.classList.add('disabled');
    this.atcBtn.textContent = this.oos_text;
  }

  enableATC() {
    this.atcBtn.removeAttribute('disabled');
    this.atcBtn.classList.remove('disabled');
    this.atcBtn.innerHTML = `
      <svg
      class="shopping-bag-mob"      
      width="24"
      height="24"
      viewBox="0 0 14 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.66822 4.67533V5.99984C3.66822 6.36803 3.96669 6.6665 4.33488 6.6665C4.70307 6.6665 5.00155 6.36803 5.00155 5.99984V4.6665L9.00155 4.6665V5.99984C9.00155 6.36803 9.30003 6.6665 9.66822 6.6665C10.0364 6.6665 10.3349 6.36803 10.3349 5.99984V4.67533C10.4226 4.67849 10.5027 4.68279 10.5772 4.68862C10.845 4.70961 10.9849 4.74764 11.0854 4.79532C11.3244 4.90878 11.5242 5.09076 11.6595 5.31813C11.7164 5.41369 11.7673 5.54949 11.8132 5.81419C11.8605 6.08699 11.8941 6.44075 11.9431 6.96337L12.3431 11.23C12.4011 11.8481 12.4401 12.2701 12.443 12.5972C12.4459 12.9172 12.412 13.0803 12.3637 13.1928C12.2458 13.4672 12.0392 13.6941 11.777 13.8371C11.6694 13.8957 11.5102 13.9447 11.1913 13.9717C10.8654 13.9993 10.4416 13.9998 9.82085 13.9998H4.18225C3.56152 13.9998 3.13767 13.9993 2.81175 13.9717C2.49289 13.9447 2.33365 13.8957 2.22609 13.8371C1.96392 13.6941 1.75733 13.4672 1.63944 13.1928C1.59108 13.0803 1.55718 12.9172 1.56007 12.5972C1.56303 12.2701 1.60204 11.8481 1.65998 11.23L2.05998 6.96337C2.10897 6.44075 2.14261 6.08699 2.18992 5.81419C2.23583 5.54949 2.28675 5.41369 2.3436 5.31813C2.47887 5.09076 2.67871 4.90877 2.91772 4.79532C3.01817 4.74764 3.15813 4.70961 3.42595 4.68862C3.50035 4.68279 3.58052 4.67849 3.66822 4.67533ZM10.2695 3.33945C10.4177 3.34328 10.5548 3.34944 10.6814 3.35936C11.0297 3.38668 11.3505 3.44526 11.6572 3.59081C12.1352 3.81771 12.5349 4.18169 12.8054 4.63643C12.9789 4.92811 13.0672 5.24204 13.1269 5.58637C13.1842 5.91677 13.2223 6.32283 13.2682 6.813L13.6733 11.1345C13.7279 11.7165 13.7728 12.1949 13.7763 12.5851C13.78 12.9888 13.7416 13.3633 13.5887 13.7192C13.3529 14.268 12.9398 14.7217 12.4154 15.0076C12.0753 15.1931 11.7061 15.2662 11.3038 15.3003C10.915 15.3332 10.4344 15.3332 9.84981 15.3332H4.15329C3.56868 15.3332 3.08814 15.3332 2.69931 15.3003C2.29703 15.2662 1.92781 15.1931 1.5877 15.0076C1.06334 14.7217 0.650171 14.268 0.414395 13.7192C0.261464 13.3633 0.223145 12.9888 0.226795 12.5851C0.230322 12.1949 0.275184 11.7165 0.32976 11.1344L0.734894 6.81299C0.780839 6.32283 0.818901 5.91677 0.876199 5.58636C0.93591 5.24204 1.02419 4.92811 1.19772 4.63643C1.46825 4.18169 1.86794 3.81771 2.34594 3.59081C2.65256 3.44526 2.97335 3.38667 3.32175 3.35936C3.44831 3.34944 3.5854 3.34328 3.73363 3.33945C4.04005 1.81483 5.3867 0.666504 7.00155 0.666504C8.61641 0.666504 9.96306 1.81483 10.2695 3.33945ZM8.88775 3.33317C8.61319 2.55638 7.87236 1.99984 7.00155 1.99984C6.13074 1.99984 5.38991 2.55638 5.11536 3.33317L8.88775 3.33317Z" fill="currentColor"/>
    </svg>
      ${this.atc_text}
    `;
  }

  change(delta) {
    const value = Number(this.quantityInput.value);
    this.quantityInput.value = this.normalize(value + delta);
    this.quantityInput.dispatchEvent(new Event('change')); // ako ti treba event dalje
  }

  normalize(v) {
    v = Number(v);
    if (isNaN(v)) v = this.min;
    if (v < this.min) v = this.min;
    if (v > this.max) v = this.max;
    return v;
  }

  handleStickyAddToCard() {
    document.addEventListener("DOMContentLoaded", () => {
      const atc = document.querySelector(".pdp-sticky-atc");
      if (!atc) return;

      const atcOffset = atc.offsetTop;
      const atcHeight = atc.offsetHeight;

      let isSticky = false;

      const onScroll = () => {
        if (window.innerWidth < 767) {
          const scrollY = window.scrollY - 50;
          const viewportBottom = scrollY + window.innerHeight;

          //not sticky
          if (viewportBottom < atcOffset + atcHeight || scrollY < atcOffset) {
            if (isSticky) {
              atc.classList.add("is-hidden");
              atc.addEventListener(
                "transitionend",
                () => {
                  atc.classList.toggle("is-fixed-bottom");
                  atc.classList.remove("is-hidden");
                },
                { once: true }
              );
              isSticky = false;
            }
            return;
          }

          //become sticky
          if (!isSticky && scrollY >= atcOffset) {
            atc.classList.add("is-hidden");
            atc.addEventListener(
              "transitionend",
              () => {
                atc.classList.toggle("is-fixed-bottom");
                atc.classList.remove("is-hidden");
              },
              { once: true }
            );
            isSticky = true;
          }
        }
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    });
  }

  handleQuantityInput() { 
    this.quantityInput.addEventListener("change", () => {
      let value = parseInt(this.quantityInput.value);
      this.quantityOptions.forEach((input, index ) => {
        if(value >= parseInt(input.value)) {          
          if((this.quantityOptions[index+1] && (this.quantityOptions[index+1].value > value )) || !this.quantityOptions[index+1]) {
            this.quantityOptions[index].checked = true;
          }
        }
      })
    });
  }

  handleQuantityOptions() {    
    this.quantityOptions.forEach((input) => {
      input.addEventListener("change", () => {
        if(this.quantityInput) {
          this.quantityInput.value = input.value;
        }
      });
    });
  }

  updateURLWithVariant(variantId) {
    const url = new URL(window.location);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url);
  }

  handleVariantChange(event) {
    const variantId = event.target.value;
    const variantTitle = event.target.dataset.title;
    const stock = event.target.dataset.stock;
    const variantPrice = event.target.dataset.price;
    const variantComparePrice = event.target.dataset.comparePrice;
    const currency = event.target.dataset.currency;
    const variantImage = event.target.dataset.img;

    this.handleStockAmount(stock);
    this.updateURLWithVariant(variantId);

    this.variantInputs.forEach((i) => {
      i.closest("label")?.classList.remove("product-form__label-checked");
    });
    event.target.closest("label")?.classList.add("product-form__label-checked");

    if (variantTitle) {
      this.variantTitle.textContent = variantTitle;
    }

    let imgWrapper = document.querySelector(".product__one-image img");
    if (imgWrapper) {
      imgWrapper.src = variantImage;
      imgWrapper.srcset = "";
    }
  }

  handleStockAmount(stock) {
    if (this.productStockBlock) {
      const stockFigure = this.productStockBlock.querySelector(
        ".product__stock-figure"
      );
      const stockSpan = this.productStockBlock.querySelector(
        ".product__stock-text"
      );      

      const policy = this.productStockBlock.dataset.policy;

      const oosText = this.productStockBlock.dataset.oosText;
      const oosColor = this.productStockBlock.dataset.oosColor;

      const availableText = this.productStockBlock.dataset.onstockText;
      const availableColor = this.productStockBlock.dataset.onstockColor;

      if(policy == 'deny' && stock == 0) {
        stockSpan.textContent = oosText;
        stockFigure.style.backgroundColor = oosColor;
      } else if(policy == 'deny' && stock < 0) {
        if(oosColor && oosText) {
          stockSpan.textContent = oosText;
          stockFigure.style.backgroundColor = oosColor;
        }
      } else {
        if (availableText && availableColor) {
          stockSpan.textContent = availableText;
          stockFigure.style.backgroundColor = availableColor;
        }
      }              
    }
  }
}

customElements.define("main-product", MainProduct);
